import _get from 'lodash/get';
import _isEmpty from 'lodash/isEmpty';
import Config from 'utils/getEnvConfig';
import { getLocalData } from 'utils/localDataStore';

export const { env } = Config;

export const firebaseConfig = Config.FIREBASE;

export const rrfConfig = {
  userProfile: 'users',
  useFirestoreForProfile: true,
  updateProfileOnLogin: false,
  profileFactory: (data, profile) => {
    const helperProviderData =
      profile.providerData || data.providerData || data.user.providerData;
    const verified =
      _get(data, 'emailVerified', false) ||
      _get(data, ['user', 'emailVerified'], false) ||
      false;
    const providerData = JSON.parse(JSON.stringify(helperProviderData));
    const insurance = getLocalData('insurance');
    const isInsuranceSet = !_isEmpty(insurance);
    return {
      updatesSubscription: false,
      leadMentalHealthSubscription: false,
      role: 'user',
      showContentfulTools: false,
      brand: getLocalData('brand') || 'none',
      insurance: isInsuranceSet ? insurance : [],
      ...profile,
      providerData: providerData[0],
      verified,
    };
  },
};

export default { env, firebaseConfig, rrfConfig };
